import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  useContext,
} from 'react';
import Approvalauthority from './Approvalauthority';
import { DataContext } from '../context/DataProvider';
import { FaChevronDown } from 'react-icons/fa';
import { IoIosClose } from 'react-icons/io';
import FetchParent from './FetchParent';

const SearchableDropDownFetchParent = ({ ParentID }) => {
  const {ParentId,setParentId } = useContext(DataContext);
  const [searchText, setSearchText] = useState('');
  const [clickText, setclickText] = useState('');
  const [pageNumber, setPageNumebr] = useState(1);
  const [openMenu, setOpenMenu] = useState(false);
  const [organTitle, setOrganTitle] = useState({});
  const observe = useRef();
  const { loading, error, hasMore, ParentArray } = FetchParent(
    searchText,
    pageNumber,
  );

  useEffect(() => {
        if(ParentID!==null)
       {
        fetch(
          `${process.env.REACT_APP_BASE_URL}/api/Page/GetById?id=${ParentID}`
        )
          .then((res) => res.json())
          .then((data) => setclickText(data.title));
       }
     
    
   
  }, [ParentID]);
// console.log(organTitle)
  const handelChange = (e) => {
    setSearchText(e.target.value);
    setclickText(e.target.value);
    setPageNumebr(1);
  };
  const handleonClick = () => {
    setOpenMenu(!openMenu);
  };
  // console.log()
  const lastorgElement = useCallback(
    (node) => {
      if (loading) return;
      if (observe.current) observe.current.disconnect();
      observe.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumebr((prevPageNumber) => prevPageNumber + 1);
          // console.log("visiable");
        }
      });
      //   if (node) observer.current
      //   console.log(node);
      if (node) observe.current.observe(node);
    },
    [loading, hasMore],
  );
  const handleClick = (item: {}) => {
    setParentId(item.value);
    setclickText(item.label);
    setOpenMenu(false);
  };
  const emptyInput = (e) => {
    e.preventDefault();
    setclickText('');
    setParentId(null);
  };
  return (
    <div className="w-full md:mt-4 z-52 flex flex-col">
      <div className="relative ltr py-1  flex items-center">
        <input
          className="border text-[14px] border-gray-200 p-2 absolute z-5 rounded-md w-full focus:outline-none text-right "
          placeholder="...جستجو"
          onChange={handelChange}
          onClick={handleonClick}
          value={clickText}
          // defaultValue={organTitle.Title}
        />
        <div className="absolute  flex items-center justify-center py-3/1 rounded-md px-2">
          {clickText === '' ? (
            <>
              <button className=" ltr mr-2  text-center">
                <FaChevronDown className="text-[12px] text-gray-400" />
              </button>
              <div className="text-gray-400">|</div>
            </>
          ) : (
            <>
              <button className="" onClick={emptyInput}>
                <IoIosClose className="text-[20px] text-gray-400" />
              </button>
            </>
          )}
        </div>
        {/* <div className=""><FaChevronDown /></div> */}
      </div>
      {openMenu && (
        <div className="w-[30.5%] bg-[#ffffff] absolute z-5  h-60 border rounded-md mt-6  overflow-y-auto">
          {Array.from(ParentArray).map((i, index) => {
            if (Array.from(ParentArray).length === index + 1) {
              return (
                <div
                  onClick={() => handleClick(i)}
                  ref={lastorgElement}
                  key={i.value}
                  className="cursor-pointer hover:bg-blue-100 py-2 px-1"
                >
                  {i.label}
                </div>
              );
            } else {
              return (
                <div
                  onClick={() => handleClick(i)}
                  className="cursor-pointer hover:bg-blue-100 py-2 px-1"
                  key={i.value}
                >
                  {i.label}
                </div>
              );
            }
          })}
          <div>{loading && 'loading...'}</div>
          {/* {error && <div>error...</div>} */}
        </div>
      )}
    </div>
  );
};

export default SearchableDropDownFetchParent;
